<template>
  <div class="word-page auto">

    <div class="title auto"><b>个人信息保护政策</b></div>

    <div class="block auto">
      生效日期：2023年11月17日
    </div>
    
    <div class="block auto">
      我们深知个人信息对您的重要性，将严格依据法律法规，保护您的个人信息安全。因此，现代汽车（中国）投资有限公司（以下统称为"现代汽车高性能N品牌"或"我们"）制订了本政策，阐述我们如何收集、使用、披露、共享以及储存您的个人信息。现代N应用由现代汽车（中国）投资有限公司委托上海隅西网络科技有限公司开发并维护，上海隅西网络科技有限公司负责应用的运营和技术支持。我们可能会与上海隅西网络科技有限公司共享您的数据，以便为您提供更好的服务。同时，我们会通过本政策向您说明，您如何实现访问、更正、请求删除、复制您个人信息的权利，以及我们如何保护您的个人信息。
    </div>

    <div class="block auto">
      本政策适用于现代汽车高性能N品牌的网站、APP、微信小程序、微信公众号、微博账号、抖音等平台以及现代汽车高性能N品牌提供的任何其他链接页面、功能、内容或应用程序服务。（以下统称为网站）。
      <b>
        本政策与您使用我们的服务关系紧密，我们努力用通俗易懂、简明扼要的文字表达，并对本政策中与您的权益存在重大关系的条款，采用粗体字进行标注以提示您注意。请您务必仔细阅读并透彻理解本政策全部内容，并在接受后使用相关服务。一旦您开始或持续使用各项服务，即表示您已充分理解并同意本政策及其更新后的内容。
      </b>
    </div>

    <div class="block auto">
      我们制定本政策的目的在于帮助您了解以下内容：<br>
      1. 个人信息的收集和使用<br>
      2. 如何使用cookie技术<br>
      3. 个人信息的保存<br>
      4. 向第三方共享、转让和公开披露您的个人信息<br>
      5. 您的权利<br>
      6. 第三方通过我们的网站向您收集个人信息<br>
      7. 免责事由<br>
      8. 未成年人个人信息保护<br>
      9. 本政策如何更新<br>
      10. 如何联系我们
    </div>

    <div class="block auto">
      <b>第一条：个人信息的收集和使用</b><br>
      我们为向您提供服务、提升我们的服务质量以及优化您的服务体验，我们会在符合法律规定或根据本声明所列您授权的情况下使用您的个人信息，并主要用于以下情形：<br>
      1.账户注册与登录<br>
      当您注册或登录现代汽车高性能N品牌的网站时，我们会收集您的手机号码验证您的身份，并用以创建您的账户。为实现向您提供更优质的服务，您可以自愿选择在账户注册和使用过程中向我们提供：您的头像、昵称、电子邮箱等信息，如果您不提供该等信息，不会影响您正常享受现代汽车高性能N品牌网站的基本功能。我们使用移动智能终端补充设备标识体系统调用SDK，帮助您使用手机账号登录APP，将收集以下信息: 网络访问，获取Wi-Fi状态，读取电话状态，写入外部存储，使用存储权限读取外置存储信息，设备标识信息 (包括IMEI、设备序列号、OAIDMEID、Android ID、IMSIGUID、MAC地址、SIM卡序列号)、已安装APP信息、传感器信息、剪切板。<br>
      2.商城购物及支付<br>
      当您通过现代汽车高性能N品牌的网站进行购物和支付服务时，我们会收集完成相关服务所需要的个人信息。如不提供特定的信息，您将无法使用与之对应的功能，但不影响您使用网站的其他服务。<br>
      1）下单及订单管理：您可以通过现代汽车高性能N品牌的网站购买或用积分兑换相关商品。在下单过程中，我们会收集收货人的姓名、收货地址、收货人电话号码。同时我们会通过系统为您生成购买该商品的订单，该订单中会载明您所购买或积分兑换的商品信息、具体订单号、订单创建时间、支付方式、订单金额。当您申请发票开具时，为了提供相关服务，我们会收集您的电子邮箱和发票抬头信息。当您申请退换货时，为了提供相关服务，我们会收集收货人的姓名、收货地址、收货人联系方式。<br>
      2）订单支付：您下单后可以选择第三方支付机构所提供的支付服务。现代汽车高性能N品牌的网站嵌入的第三方支付机构的支付软件工具开发包会收集完成支付需要的信息。同时我们会将您的订单号与交易金额信息与这些支付机构共享，以实现其确认您的支付指令并完成支付。<br>
      3.社区与即时通讯<br>
      为了方便您共享用户体验，现代汽车高性能N品牌的网站提供了用户社群交流功能。在您使用该等服务时，我们会记录您的昵称、关注、粉丝情况、您发布和收藏的内容、<b>您的社区浏览历史</b>、评论和点赞情况。我们会收集您发布的内容（包括文字、图片或视频）。<b>请注意，您公开发布的信息中可能会涉及您或他人的个人信息甚至敏感个人信息。请您更加谨慎的考虑，是否在使用我们的服务时共享甚至公开分享相关信息。若您想我们提供或发布的信息中涉及他人个人信息时，您需要在发布前征得他人的同意。</b><br>
      4.活动报名<br>
      当您通过现代汽车高性能N品牌的网站报名参加活动时，根据活动的具体要求，我们会收集您以及同行人（如有同行人）的姓名、电话号码、邮寄地址（具体以活动页面收集的信息为准）。<b>当您为他人报名参加活动或者提供同行人前述信息时，请确保已取得个人信息主体或者其监护人的同意。</b><br>
      5.客户服务<br>
      当您与我们的客户服务人员沟通时，我们需要您提供必要的个人信息以核验您的身份。基于您的不同需求，需要您提供不同的信息，如果您针对具体车辆、产品/服务、账户或订单进行咨询、投诉或提供建议，我们需要查看、使用您的车辆相关信息、具体产品/服务的服务数据、账户信息、订单信息以便我们为您解决问题，具体以实际沟通场景为准。我们会保留您与客户服务人员的沟通记录，以便我们处理纠纷、解决问题或向您反馈结果。<br>
      6.信息推送<br>
      为了将我们的最新产品、服务、衍生产品及服务、活动预告、抽奖、竞赛或促销推广活动等及时告知您，我们会使用您的手机号码、电子邮箱向您发送广告、促销和推广营销信息，邀请您参与有关我们的产品/服务的调查或我们组织的会员活动。如果您不想接受我们向您发送的上述信息，您可以通过这些信息中提供的退订机制退订这些信息，或根据以下“联系我们”部分所列的方式与我们联络以退订这些信息。<br>
      7.业务经营以及分析改进<br>
      为了改进我们的产品、服务及与您之间的沟通，就我们已收集的信息，我们会通过技术手段进行匿名化或去标识化处理后，进行研究、加工、统计、分析，形成不包含可识别您个人身份的信息、报告，为企业审计等正常业务经营目的使用，或用以改善和优化我们的产品/服务、进行新产品研发、或提供商业决策参考。<br>
      为识别您的设备并预防恶意程序及反作弊、提高服务安全性、保障运营质量及效率，我们会收集您的设备信息 (包括IMEI、OAID、MEID、Android ID、 MAC地址)、已安装APP信息或运行中的进程信息。<br>
      为实现垃圾清理与运行加速功能，我们将请求您的存储权限获取外置存储信息(SD卡数据)，用以检查手机CPU、内存和SD卡情况。<br>
      当你播放视频等内容时，为了适配你的设备状态，我们会调用设备的重力、加速度等传感器信息，以识别你的设备横竖屏状态<br>
      在你分享或接收被分享的信息时，需要在本地访问你的剪切板读取其中包含的口令、分享码、链接，以实现跳转、分享、活动联动等功能或服务<br>
      为识别您的设备并预防恶意程序及反作弊、提高服务安全性、保障运营质量及效率，我们会收集您的设备信息 (包括IMEI、OAID、MEID、Android ID、 MAC地址)、软件安装列表、已安装APP信息或运行中的进程信息。<br>
      8.第三方SDK说明：<br>
      为保障APP相关功能的实现与应用的稳定运行，我们可能会接入由第三方提供的软件开发包（SDK）以实现相关目的，以下为第三方SDK说明：<br><br>
      第三方公司名称：网易（杭州）网络有限公司<br>
      SDK名称：com.qiyukf（七鱼）<br>
      使用场景：用户在APP内联系客服时使用<br>
      收集信息类型：用户昵称、用户头像、注册手机号、邮箱<br>
      使用目的：提供客服服务<br>
      收集方式：SDK本机采集<br><br>

      第三方公司名称：财付通支付科技有限公司<br>
      SDK名称：微信支付<br>
      使用场景：在用户购买商品场景中，用户选择微信支付方式时使用<br>
      收集信息类型：支付金额、支付时间、订单号、设备类型、设备型号、操作系统<br>
      使用目的：使用微信支付功能<br>
      收集方式：SDK本机采集<br><br>

      第三方公司名称：每日互动股份有限公司<br>
      SDK名称：com.igexin.push（消息推送）<br>
      使用场景：向用户推送信息<br>
      收集信息类型：存储的个人文件、设备信息（包括IMEI、MAC地址、ANDROID_ID、DEVICE_ID、IMSI）、OAID、设备广告标识符（GAID）、网络信息（包括SSID、BSSID、DHCP信息）、运营商信息、应用已安装列表<br>
      使用目的：能准确推送消息到用户手机<br>
      收集方式：SDK本机收集<br><br>

      第三方公司名称：广东欢太科技有限公司<br>
      SDK名称：OPUSH SDK<br>
      使用场景：向使用OPPO设备的用户推送信息<br>
      收集信息类型：应用基本信息（MCS应用包名、应用版本号、OPUSH SDK版本号）、应用内设备标识符（RegistraterID、appKey、appSecret）、操作系统版本<br>
      使用目的：消息推送服务<br>
      收集方式：SDK本机收集<br><br>

      第三方公司名称：维沃移动通信有限公司<br>
      SDK名称：vivo 推送<br>
      使用场景：向使用vivo设备的用户推送信息<br>
      收集信息类型：应用基本信息（MCS应用包名、应用版本号、OPUSH SDK版本号）、应用内设备标识符（RegistraterID、appKey、appSecret）、系统与网络信息<br>
      使用目的：保证vivo用户能准确接收到推送的消息<br>
      收集方式：SDK本机采集<br><br>

      第三方公司名称：北京小米科技有限责任公司<br>
      SDK名称：小米推送<br>
      使用场景：向使用小米设备的用户推送信息<br>
      收集信息类型：Android ID、OAID、设备厂商、设备型号、操作系统版本、网络类型、应用信息（应用包名、应用版本号、Mi Push SDK版本号）<br>
      使用目的：保证小米用户能准确接收到推送的消息<br>
      收集方式：SDK本机采集<br><br>

      第三方公司名称：华为软件技术有限公司<br>
      SDK名称：华为推送<br>
      使用场景：向使用华为设备的用户推送信息<br>
      收集信息类型：应用信息（应用包名、应用版本号、目标API级别）、设备标识信息（AAID（应用匿名标识符）、Push Token、设备厂商、设备型号）<br>
      使用目的：能准确推送消息到用户手机<br>
      收集方式：SDK本机收集<br><br>

      第三方公司名称：高德软件有限公司<br>
      SDK名称：高德开放平台地图SDK<br>
      使用场景：查看地图、查询路线等<br>
      收集信息类型：位置信息，设备信息（WIFI的SSID、BSSID）<br>
      使用目的：实现地图展示、定位等服务，其中读取WIFI扫描结果用于辅助定位等<br>
      收集方式：SDK本机收集<br><br>

      第三方公司名称： 中国信息通信研究院<br>
      SDK名称： 卓信ID SDK<br>
      使用场景： 用户注册、登录、实名认证<br>
      收集信息类型： 网络信息（IP地址、MAC地址），设备信息（OAID），手机号码，应用安装列表<br>
      使用目的： 实现一键登录和认证服务，其中读取网络状态、设备信息用于安全风控、检测欺诈行为<br>
      收集方式： SDK本机收集
      <!-- 8.个性化内容推荐<br>
      <b>为向您展示更契合您需求的产品或服务信息，我们会收集您使用我们的产品或服务的信息以及其他获得您明示授权同意的信息，用以向您推荐或展示您可能感兴趣的内容。</b>我们将努力保障您的隐私安全，如您希望管理个性化内容推荐功能，您可以在“用户中心”-“设置”-“隐私设置”-“个性化推荐”中进行设置。 -->
    </div>

    <div class="block auto">
      <b>第二条 如何使用cookie技术</b><br>
      在您访问我们的网站时，我们会通过Cookies和其他追踪技术了解您使用现代汽车高性能N品牌网站的情况，用以向不同群体客户提供更有针对性、更有价值的产品信息和服务。您理解并同意我们将通过Cookies收集您的信息（如登陆状态，登陆时间，登陆有效值）并会将收集的信息与您的其他信息结合使用。我们不会将Cookie用于本隐私政策所述目的之外的任何用途。大部分浏览器会自动打开Cookies，但您可以随时调整您的浏览器设置,选择关闭Cookies。
    </div>

    <div class="block auto">
      <b>第三条：个人信息的保存</b><br>
      我们向您承诺，对所收集的个人信息严格保密，并设置合理且足够的安保措施来保护您的个人信息免受未经授权的访问、泄露和丢失。<br>
      我们将您的个人信息存储在位于中国境内（张家口）的服务器上，该等个人信息通常不会被跨境传输至中国境外。但为本隐私政策规定的目的，在履行适用法律、法规规定的数据出境安全评估义务并获取您的同意（如适用）和评估后，我们有可能合法合规地传输该等信息至我们在韩国的关联公司等境外主体。<br>
      我们仅在为实现本隐私政策所述目的所必需的期限内留存您的个人信息，法律法规另有规定或者个人信息主体另外授权同意的除外。根据您使用的服务场景不同，您的个人信息存储期限可能会有所差别，我们用于确定存留期的标准包括：完成与您相关的服务的目的需要留存个人信息的时间，包括提供服务、维护相关记录、应对您可能的查询或投诉；保证我们为您提供服务的安全和质量；法律、合同等是否有保留数据的特殊要求等。只要您的账户是为您提供服务所必需，我们都将保留您的注册信息。
    </div>

    <div class="block auto">
      <b>第四条：向第三方共享、转让和公开披露您的个人信息</b><br>
      1. 共享<br>
      <b>我们承诺尊重和保护您的个人信息并遵守相关的法律和法规，不会在未经您同意或授权的情况下将您的个人信息共享给第三方，但以下情形除外：</b><br>
      1）在事先获取同意的情况下共享：获得您的明确同意后，我们会与其他方共享您的个人信息。<br>
      2）共享给我们的关联公司或者合作伙伴：在本政策声明的使用目的范围内，您的个人信息可能会与我们的关联公司或合作伙伴共享，但我们只会共享必要的信息。如果我们的关联公司或者合作伙伴改变个人信息处理目的，将再次征求您的授权同意。<br>
      3）我们可能会根据法律法规规定，或按政府主管部门的强制性要求，对外共享您的个人信息。<br>
      2. 委托处理<br>
      我们可能委托授权合作方处理您的个人信息，以便其协助我们为您提供服务。比如我们需将您的订单信息共享给我们合作的物流公司，以便物流公司与您联系并交付物品。您知晓并同意该物流公司不可避免地获知及使用您的配送信息，用于完成交付目的。为使我们及时获悉并确认交付进度及状态，向您提供售后服务，您同意我们可自物流公司处获取与交付进度相关的信息。我们仅会在本政策声明的目的范围内委托其处理您的个人信息，授权合作方仅能接触其履行职责所必需的您的信息。<br>
      3. 转让<br>
      <b>我们不会将您的个人信息转让给任何公司、组织和个人、但以下情况除外：</b><br>
      1）在获取明确同意的情况下转让：获得您的明确同意后，我们会向其他方转让您的个人信息；<br>
      2） 在涉及合并、分立、解散、收购或破产清算时，如涉及到个人信息转让，我们会要求新的持有您个人信息的公司、组织继续受本政策的约束，否则我们将要求该公司、组织重新向您征求授权同意。<br>
      4. 公开披露<br>
      <b>除非在适用的法律要求或响应法律程序的情况发生，否则在事前获得您的授权同意前，我们不会公开披露您的个人信息。</b>
    </div>

    <div class="block auto">
      <b>第五条：您的权利</b><br>
      1.访问您的个人信息<br>
      如果您想访问您的现代汽车高性能N品牌网站账户信息、订单信息等信息，您可根据以下“联系我们”部分所列的方式与我们联络以访问您的个人信息。<br>
      2.更正您的个人信息<br>
      当您发现我们处理的关于您的个人信息有错误时，经对您的身份进行验证，且更正不影响信息的客观性和准确性的情况下，您有权对错误或不完整的信息作出更正或更新。您可根据以下“联系我们”部分所列的方式与我们联络。<br>
      3.删除您的个人信息<br>
      在以下情形中，您可以向我们提出删除个人信息的请求：<br>
      1）如果我们处理个人信息的行为违反法律法规；<br>
      2）如果我们收集、使用您的个人信息，却未征得您的同意；<br>
      3）如果我们处理个人信息的行为违反了与您的约定；<br>
      4）如果您不再使用我们的产品或服务，或您注销了账户；<br>
      5）如果我们不再为您提供产品或服务。<br>
      若我们决定响应您的删除请求，我们还将同时通知从我们这里获得您的个人信息的主体，要求其及时删除，除非法律法规另有规定，或这些实体获得了您的单独授权。<br>
      当您从我们的服务中删除信息后，我们可能不会立即在备份系统中删除相应的信息，但会在备份更新时删除这些信息。<br>
      您可根据以下“联系我们”部分所列的方式与我们联络。<br>
      4.改变您授权同意的范围<br>
      每个业务功能需要一些基本的个人信息才能得以完成。对于个人信息的收集和使用，您可以随时给予或撤回您的授权同意。您可根据以下“联系我们”部分所列的方式与我们联络。当您撤回同意后，我们将不再处理相应的个人信息。但您撤回同意的决定，不会影响此前基于您的授权而开展的个人信息处理。<br>
      5.个人信息主体注销账户<br>
      您随时可注销此前注册的账户，您可以通过以下方式自行操作：我的现代-个人-注销，在注销账户之后，我们将停止为您提供产品或服务，并依据您的要求，删除您的个人信息，法律法规另有规定的除外。<br>
      6.个人信息主体获取个人信息副本<br>
      您有权获取您的个人信息副本，您可以根据以下“联系我们”部分所列的方式与我们联络。在技术可行的前提下，如数据接口已匹配，我们还可按您的要求，直接将您的个人信息副本传输给您指定的第三方。<br>
      7.约束信息系统自动决策<br>
      在某些业务功能中，我们可能仅依据信息系统、算法等在内的非人工自动决策机制作出决定。如果这些决定显著影响您的合法权益，您有权要求我们作出解释，我们也将提供适当的救济方式。<br>
      8.响应您的上述请求<br>
      为保障安全，您可能需要提供书面请求，或以其他方式证明您的身份。我们可能会先要求您验证自己的身份，然后再处理您的请求。<br>
      我们将在三十天内作出答复。如您不满意，还可以通过以下途径投诉：<br>
      服务电话：400-885-3388<br>
      对于您合理的请求，我们原则上不收取费用，但对多次重复、超出合理限度的请求，我们将视情况收取一定成本费用。对于那些无端重复、需要过多技术手段（例如，需要开发新系统或从根本上改变现行惯例）、给他人合法权益带来风险或者非常不切实际（例如，涉及备份磁带上存放的信息）的请求，我们可能会予以拒绝。<br>
      <b>在以下情形中，我们将无法响应您的请求：</b><br>
      <b>1)与我们履行法律法规规定的义务相关的；</b><br>
      <b>2)与国家安全、国防安全直接相关的；</b><br>
      <b>3)与公共安全、公共卫生、重大公共利益直接相关的；</b><br>
      <b>4)与刑事侦查、起诉、审判和执行判决等直接相关的；</b><br>
      <b>5)我们有充分证据表明您存在主观恶意或滥用权利的；</b><br>
      <b>6)出于维护您或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；</b><br>
      <b>7)响应您的请求将导致您或其他个人、组织的合法权益受到严重损害的；涉及商业秘密的。</b><br>
      9.市场推广信息的退订<br>
      我们将按照适用的个人信息保护相关规定，让您选择是否接受我们、我们的关联企业或服务提供商通过电子邮件、短信、印刷材料等发送营销信息。您可通过这些信息中提供的退订机制退订这些信息，或根据以下“联系我们”部分所列的方式与我们联络以退订这些信息。
    </div>

    <div class="block auto">
      <b>第六条：第三方通过我们的网站向您收集个人信息</b><br>
      我们的网站、产品、服务中可能含有第三方网站、产品和服务的链接，我们的产品和服务也可能使用或提供来自第三方的产品或服务。第三方收集、使用您的个人信息的，须遵守第三方关于个人信息的规定。我们希望您能了解这些第三方的规定。
    </div>

    <div class="block auto">
      <b>第七条：免责</b><br>
      1.我们的一些服务，可让您向所有用户公开分享您的相关信息，例如，您在我们的服务中所上传或发布的信息、您对其他人上传或发布的信息作出的回应。使用我们服务的其他用户也有可能分享与您有关的信息。只要您不删除，有关信息会一直留存在公共领域；即使您删除相关信息，该等信息仍可能由其他用户或不受我们控制的非关联第三方独立地缓存、复制或储存，或由其他用户或该等第三方在公共领域保存，对此，现代汽车高性能N品牌不承担任何责任。<br>
      2.您理解并同意对于第三方自行通过我们的网站、产品或服务收集的、非现代汽车高性能N品牌主动向第三方共享或披露的您的个人信息，现代汽车高性能N品牌不承担任何责任。<br>
      3.您理解并同意，由于您将个人密码有意或无意告知他人、与他人共享注册帐户等由此导致的任何您的个人信息泄露，现代汽车高性能N品牌不承担任何责任。<br>
      4.您理解并同意任何由于计算机黑客攻击、计算机病毒侵入、硬件设施损坏、因政府管制而造成的暂时性关闭等影响网络正常经营的不可抗力而造成的您的个人信息泄露、丢失、被盗用或被篡改等，现代汽车高性能N品牌不承担任何责任。<br>
      5.您理解并同意我们的网站如因线路、硬件故障、系统维护、系统升级或其它不可抗力而导致暂停服务，于暂停服务期间对您造成的一切不便与损失，现代汽车高性能N品牌不承担任何责任。<br>
      6.我们无意向18周岁以下的未成年人收集任何个人信息，也不会向任何第三方透露或共享任何未成年人的信息，如未成年人通过公告或类似形式自愿提供及公开的信息被他人使用的，现代汽车高性能N品牌不承担任何责任。
    </div>

    <div class="block auto">
      <b>第八条：未成年人个人信息保护</b><br>
      我们的产品和服务仅向成年人提供，如果没有父母或其他监护人的同意，未成年人请勿向我们提供个人信息。对于我们发现自己在未事先获得可证实的父母或其他监护人同意的情况下收集了未成年人个人信息的，我们在知晓后将及时删除。
    </div>

    <div class="block auto">
      <b>第九条：本政策如何更新</b><br>
      为给您提供更好的服务，我们的产品和服务将不时变化，本政策也将随之调整。我们会在我们的网站上发出更新版本，也请您访问我们的网站以便及时了解最新的个人信息保护政策。未经您明确同意，我们不会削减您按照本个人信息保护政策所应享有的权利。
    </div>

    <div class="block auto">
      <b>第十条：如何联系我们</b><br>
      如果您对本个人信息保护政策有任何疑问、意见或建议，通过以下方式与我们联系：<br>
      服务电话：400-885-3388<br>
      邮寄地址：北京市朝阳区霄云路38号现代汽车大厦25层（100027）
    </div>

  </div>
</template>

<script>
export default {
  data () {
    return {

    }
  },
  mounted () {
    this.$wx.miniProgram.getEnv((res)=>{
      if (res.miniprogram) {
        // alert("在小程序里");
        this.$wx.miniProgram.postMessage({
          data: {
            path: '/pages/index/index'
          }
        })
      }
    })
  }
}
</script>

<style scoped>
.title {
  text-align: center;
  font-size: 1.6em;
  padding: 0 0 2em;
}
.block {
  font-size: 1.4em;
  padding-bottom: 2em;
  text-align: justify;
}
</style>